import "altcha";
import "altcha/i18n/ja";
import "altcha/i18n/zh-cn";
import "altcha/i18n/zh-tw";

// eslint-disable-next-line @typescript-eslint/unbound-method
const originalAddEventListener = EventTarget.prototype.addEventListener;

// prevent the Kentico Form Builder from adding an unwanted change event listener to the altcha checkbox
// (altcha v3 assigns an id like "altcha-checkbox-<random hex>")
EventTarget.prototype.addEventListener = function (type, listener, options) {
    const id = (this as HTMLElement).id;
    if (id && id.startsWith("altcha-checkbox") && type === "change" && typeof listener === "function") {
        if (listener.toString().includes("setTimeout")) return; // Skip adding the event listener
    }
    originalAddEventListener.call(this, type, listener, options);
};
